"use client";

import { useModalStore } from "@/store";
import Sidebar from "./sideBar";
import { FC } from "react";
import SendOtpModal from "./auth/modal/sendOtpModal";
import LoginByPassModal from "./auth/modal/loginByPassModal";
import { useToastStore } from "@/store/toastStore";
import Toast from "./ui/toast";
import CreatePasswordModal from "./auth/modal/createPasswordModal";

const AbsoluteLayouts: FC = () => {
  const { openModal, closeModal } = useModalStore();
  const { toast, closeToast } = useToastStore();

  const isSideBarOpen = openModal === "sidebar";
  const isSendOtpModal = openModal === "send-otp-modal";
  const isLoginByPassModal = openModal === "login-by-pass-modal";
  const isCreatePasswordModal = openModal === "create-password-modal";

  if (isSideBarOpen) {
    return <Sidebar isOpen={isSideBarOpen} onClose={closeModal} />;
  }
  if (isLoginByPassModal) {
    return <LoginByPassModal />;
  }
  if (isSendOtpModal) {
    return <SendOtpModal />;
  }
  if (isCreatePasswordModal) {
    return <CreatePasswordModal />;
  }
  if (toast) {
    return (
      <Toast
        message={toast.message || ""}
        position={toast.position || "top-center"}
        variant={toast.variant || "default"}
        onClose={closeToast}
      />
    );
  }
};

export default AbsoluteLayouts;
